import React, { useState, useEffect, useContext } from "react";
import {
  RESOLVE_EVENT,
  NOTIFICATIONS_QUERY,
  PAYMENT_METHODS_QUERY,
} from "utils/mutations";
import { useMutation } from "@apollo/react-hooks";
import axios from "axios";
import Loading from "components/common/Loading";
import { ServerNotificationsContext } from "components/common/wrappers/withServerNotifications";
import FinicityConnect from "components/common/FinicityConnect";

const UpdateAccountFinicity = ({ setErrorMessage, complete, reset, itemId, open }) => {
  const [link, setLink] = useState();
  const [loading, setLoading] = useState(true);
  const [resolveEvent] = useMutation(RESOLVE_EVENT);
  const { getServerNotifications } = useContext(ServerNotificationsContext);

  useEffect(() => {
    const getFinicityLink = async () => {
      console.log('gettting link...');
      const jwt = window.localStorage.getItem("jwt");
      try {
        const res = await axios.post("/api/v2/accounts/getFinicityFix", {
          itemId,
        },           {
          headers: { Authorization: `Bearer ${jwt}` },
        });

        setLoading(false);
        const {
          data: { link, resolved, error } = {},
        } = res;
        if (error) {
          console.log("Error getting public token:", error);
          return;
        }
        if (resolved) {
          getServerNotifications();
          return;
        }
        console.log("link", link);
        if (link) { setLink(link); }
      } catch (err) {
        setLoading(false);
      }
    };
    getFinicityLink();
  }, [itemId, getServerNotifications]);

  const updateEvent = async () => {
    resolveEvent({
      variables: {
        id: itemId,
        aggregator: 'finicity',
      },
      refetchQueries: [
        { query: NOTIFICATIONS_QUERY },
        { query: PAYMENT_METHODS_QUERY },
      ],
    }).then(() => {
      getServerNotifications();
      complete();
      reset();
      setLink();
    });
  };
  // useEffect(() => {
  //   if (link && plaidLoaded && !buttonClicked) {
  //     const plaidDivEl = document.getElementById("plaid-button-div");
  //     const plaidButtonEl = plaidDivEl.getElementsByTagName("button");
  //     plaidButtonEl[0].click();
  //     setButtonClicked(true);
  //   }
  // }, [link, plaidLoaded, buttonClicked]);

  // const onSuccess = () => {
  //   resolveEvent({
  //     variables: {
  //       id: itemId
  //     },
  //     refetchQueries: [
  //       { query: NOTIFICATIONS_QUERY },
  //       { query: PAYMENT_METHODS_QUERY }
  //     ]
  //   }).then(() => {
  //     getServerNotifications();
  //     complete();
  //     reset();
  //     setToken();
  //     setButtonClicked();
  //     setPlaidLoaded();
  //   });
  // };

  // const onLoad = (error, metadata) => {
  //   if (!plaidLoaded) setPlaidLoaded(true);
  //   console.log("plaid onLoad - error:", error, "metadata: ", metadata);
  // };

  // const onExit = (error = {}, metadata = {}) => {
  //   console.log("plaid onExit - error:", error, "metadata:", metadata);
  //   if ((error !== null ? error : {}).error_code === "item-no-error") {
  //     console.log(
  //       "PlaidLink reported that the item run in update mode is in a good state. Resolving event."
  //     );
  //     resolveEvent({
  //       variables: {
  //         id: itemId
  //       },
  //       refetchQueries: [
  //         { query: NOTIFICATIONS_QUERY },
  //         { query: PAYMENT_METHODS_QUERY }
  //       ],
  //       awaitRefetchQueries: true
  //     }).then(() => {
  //       getServerNotifications();
  //       complete();
  //       reset();
  //       setPlaidLoaded();
  //       setToken();
  //       setButtonClicked();
  //     });
  //   } else {
  //     reset();
  //     setPlaidLoaded();
  //     setToken();
  //     setButtonClicked();
  //   }
  // };

  // const onEvent = (eventType, metadata) => {
  //   console.log("plaid onEvent - type:", eventType, "metadata: ", metadata);

  //   if (eventType === "OPEN") {
  //     setErrorMessage("");
  //   }
  //   if (eventType === "ERROR" && metadata.error_code) {
  //     if (metadata.error_code === "NO_AUTH_ACCOUNTS") {
  //       setErrorMessage("No valid checking or savings account(s) found");
  //     } else {
  //       setErrorMessage(
  //         "Something went wrong. Please try again or contact support."
  //       );
  //     }
  //     console.log(
  //       "Plaid link reported an error: Error code",
  //       metadata.error_code,
  //       "-",
  //       metadata.error_message
  //     );
  //   }
  //   if (eventType === "HANDOFF") {
  //     console.log("Handoff");
  //   }
  // };

  // if (!open) return null;

  if (loading) { return <Loading />; }

  return link ? (
    <div>
      <FinicityConnect
        linkURL={link}
        show
        hidden
        onSuccess={(data) => {
          console.log("onSuccess data:", data);
          updateEvent();
        }}
        onCancel={(data) => {
          console.log("onCancel data:", data);
        }}
        onError={(data) => {
          console.log("onError data:", data);
          if (data?.code === 201) {
            updateEvent();
          }
        }}
        onLoaded={(data) => {
          console.log("onLoaded data:", data);
        }}
        onRouteEvent={(data) => {
          console.log("onRouteEvent data:", data);
        }}
        onUserEvent={(data) => {
          console.log("onUserEvent data:", data);
          if (data?.data?.action === "End" && data?.code === 201) {
            updateEvent();
          }
        }}
        buttonText="Re-link"
        buttonClassName="shadow-xl bg-red-400 hover:bg-red-500 text-sm font-medium text-white px-2 py-1 rounded w-full cursor-pointer"
      />
    </div>
  ) : null;
};

export default UpdateAccountFinicity;
